import React from 'react';

const FileSpreadSheetIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
            <path d="M8 13h2"/>
            <path d="M14 13h2"/>
            <path d="M8 17h2"/>
            <path d="M14 17h2"/>
        </svg>
    );
};

export default FileSpreadSheetIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/FileSpreadSheetIcon.jsx